import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from 'react-skeleton-loader';


function CardLayoutLoader(props) {
    const classes = useStyles();

    return (
        <div className={classes.wrapper}>
            <div >
                <Skeleton height="80px" width="100%" color="#ccc" />
            </div>
            <br />
            <div >
                <Skeleton height="80px" width="100%" color="#ccc" />
            </div>
            
            <br />
            <div >
                <Skeleton height="80px" width="100%" color="#ccc" />
            </div>
            <br />
            <div >
                <Skeleton height="80px" width="100%" color="#ccc" />
            </div>
            
            <br />
            <div >
                <Skeleton height="80px" width="100%" color="#ccc" />
            </div>
        </div>
    )
}
const useStyles = makeStyles({
    wrapper: {
        width: '100%'
    },
    txtWrapper: {
        width: '100%'
    }
})

export default CardLayoutLoader;